import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[bookshelfTemplateTitle]',
})
export class BookshelfTemplateTitleDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
